export default __webpack_public_path__ + "static/media/gnb-w@2x.b688b66e.png";